import Restriction from "../restriction";
import meshRestrictionHelper from "../meshRestrictionHelper";

class RestrictGroup extends Restriction {
    constructor() {
        super({
            type: meshRestrictionHelper.RestrictedMeshTypeEnum.GROUP,
            allowedTypesToPopulate: [
                meshRestrictionHelper.RestrictedMeshTypeEnum.TREE,
                meshRestrictionHelper.RestrictedMeshTypeEnum.VOLUME
            ]
        });
    }

    _getSelectedGroups(groupNames = []) {
        const selectedGroupNames = GroupController.getSelectedGroupNames();
        if (groupNames.length === 0 && selectedGroupNames.length === 0) return [];

        selectedGroupNames.forEach(groupName => {
            if (!groupNames.includes(groupName)) groupNames.push(groupName);
        });

        return groupNames;
    }

    isValid(groupNames = []) {
        groupNames = this._getSelectedGroups(groupNames);

        let invalidGroupNames = [];
        groupNames.forEach(groupName => {
            if (!super.isValid(groupName)) invalidGroupNames.push(groupName);
        });

        if (invalidGroupNames.length > 0) {
            console.error('Restricted groups found: ' + invalidGroupNames);
        }

        return invalidGroupNames.length === 0;
    }

    getPopulatedDataByType(groups, applyTo, mode = meshRestrictionHelper.RestrictionMode.ALLOW_ALL) {
        let data = [];
        let groupNames = groups.map(group => group.name);
        if (mode === meshRestrictionHelper.RestrictionMode.DENY_ALL) {
            groups = GroupData.getGroupList();
            groupNames = groups.map(group => group.name);
        }
        if (applyTo === this.type) data = groupNames;

        groupNames.forEach(groupName => {
            if (this.allowedTypesToPopulate.includes(applyTo)) {
                data.push(...getDataBasedOnAppliedType(applyTo, groupName));
            }
        });

        return data;

        function getDataBasedOnAppliedType(type, groupName) {
            let group;
            switch (type) {
                case meshRestrictionHelper.RestrictedMeshTypeEnum.VOLUME:
                    group = GroupData.getGroupByName(groupName);
                    return group ? group.getValidVolumeBranchIds() : [];
                case meshRestrictionHelper.RestrictedMeshTypeEnum.TREE:
                    group = GroupData.getGroupByName(groupName);
                    return group ? group.branchList : [];
                default:
                    return [];
            }
        }
    }
}

export default RestrictGroup;